<template>
<div>
  <v-dialog persistent v-model="showDialogEditUser" max-width="500px">
    <v-card>
      <v-form v-on:submit.prevent="updateUser" v-model="valid" ref="updateUserForm">
        <v-card-title>
          <v-layout wrap>
              <v-flex xs12>
                <h1>Actualizar listas </h1><br/>
              </v-flex>
              <v-flex xs12 v-if="user">
                <h3 >{{user.name}}</h3>
              </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md style="padding: 2px">
            <v-layout wrap>
               <v-select
                  v-model="selectedList"
                  prepend-inner-icon="list"
                  :items="priceLists"
                  item-text="name"
                  item-value="id"
                  label="Acceso a Listas"
                  :solo="solo"
                  chips
                  :deletable-chips="false"
                  multiple
                  ref:="listSelect"
                >
                  <template
                    slot="selection"
                    slot-scope="data"
                  >
                    <v-chip
                      close
                      @input="remove(data.item)"
                      :color="data.item.color"
                    >
                      {{ data.item['name'] }}
                    </v-chip>
                  </template>
                </v-select>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeDialog">Cancelar</v-btn>
          <v-btn type="submit" :disabled="this.selectedList.length <= 0" color="success">Guardar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      default: undefined,
    },
    showDialogEditUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      priceLists: [],
      selectedList: [],
      password: '',
      confirmPassword: '',
      valid: true,
      solo: true,
    };
  },
  created(){
    // this.axios.get('/catalogs/priceCategory')
    // .then( (result) => {
    //   this.priceLists = result.data;
    //   if (this.user.priceLists.lenght > 0){
    //     this.selectedList.concat(this.user.priceLists)
    //   }
    // });
  },
  watch: {
    showDialogEditUser: {
        deep: true,
        handler(showDialogEditUser) {
            if(showDialogEditUser){
              this.selectedList = []
              this.priceLists = []
              this.getData()
            }
        }
    }
  },
  methods: {
    remove(item) {
      let index = this.selectedList.findIndex(it => it.id == item.id)
      console.log(index);
      if (index != -1) {
        this.selectedList.pop(index)
      }
      // this.editedUser.list = this.editedUser.list.filter( (e) => e !== item.label );
      // that.$refs.listSelect.isMenuActive  = false;
    },
    getData(){
      console.log(this.user);
      const self = this
      this.axios.get('/catalogs/priceCategory')
      .then( (result) => {
        this.priceLists = result.data;
        const userPriceList = this.user.priceLists
        if (userPriceList && userPriceList.length > 0){
          userPriceList.forEach(element => {
            this.selectedList.push(element.id)
          });
        }else {
          this.priceLists.forEach(list => {
            const key = "level_" + list.id
            const value = this.user[key]
            if (value && value == 1){
              this.selectedList.push(list.id)
            }
          })
        }
      });
    },
    isSelected(price){
      for (let index = 0; index < this.selectedList.length; index++) {
        const element = this.selectedList[index];
        if (price.id == element) {
          return true
        }
      }
      return false
    },
    async updateUser() {
      console.log(this.user);
      console.log(this.selectedList);
      let listPrice = []
      let newUserPriceList = []
      this.priceLists.forEach(price => {
        const data = {listId: price.id, active: this.isSelected(price)}
        if (data.active){
          newUserPriceList.push(price)
        }
        listPrice.push(data)
      })
      console.log(listPrice);
      const parameters = {
        list: listPrice
      };
      try {
        const result = await this.axios.put(`/users/${this.user.id}`, parameters);
        this.user.priceLists = newUserPriceList
        this.$emit('user-list-update', this.user);
      } catch (error) {
        this.$emit('error', error);
      } 
    },
    closeDialog() {
      this.$emit('close-dialog-edit-user');
    },
  },
};
</script>
